import React, { useState } from "react";

import {
  Divider,
  makeStyles,
  Typography,
  Checkbox,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Pagination } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import { Select, TextInput } from "../../components/Form";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { useAlert } from "../../components/Alert";
import TransferDialog from "./TransferDialog";
import "../../ColorBlock.css";
import divisions from "../../divisions.json";

const GET_USERS = gql`
  query users(
    $searchTerm: String
    $latest: Boolean
    $identity: Identity
    $pageSize: Int
    $page: Int
  ) {
    users(
      searchTerm: $searchTerm
      latest: $latest
      identity: $identity
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        id
        username
        fullName
        gender
        mobile
        phone
        fax
        email
        address {
          division
          subdivision
          address
        }
        status
        activatedAt
        expiredAt
        note
        createdAt
        updatedAt
      }
    }
  }
`;

export default function MemberManageTable({ onChangeSelect = () => {} }) {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    memberStateArray: [
      { label: "全部", value: "全部" },
      { label: "有付費", value: "有付費" },
      { label: "未付費", value: "未付費" },
      { label: "已到期", value: "已到期" },
    ],
    memberStateObject: { label: "全部", value: "全部" },
    searchTerm: "",
    content: "",
    open: false,
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
    DocumentContainerTextEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();
  const { data, loading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      searchTerm: newData.searchTerm,
      latest: true,
      identity: "MEMBER",
      pageSize: 10,
      page: newData.page,
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  function getAddress(division, subdivision, address) {
    if (Boolean(division) && Boolean(subdivision)) {
      return (
        divisions[division]["zhTW"] +
        divisions[division]["subdivisions"][subdivision]["zhTW"] +
        address
      );
    } else {
      return null;
    }
  }
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  }
  if (Boolean(data)) {
    return (
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid
              item
              xs={5}
              sm={2}
              classes={{ root: classes.DocumentContainerTextEnd }}
            >
              <TextInput
                value={newData.searchTerm}
                label={"關鍵字"}
                onChange={(v) => {
                  changeData("searchTerm", v, true);
                }}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={5}
              sm={2}
              classes={{ root: classes.DocumentContainerTextEnd }}
            >
              <Select
                items={newData.memberStateArray}
                value={newData.memberStateObject}
                onChange={(e, v) => {
                  changeData("memberStateObject", v, true);
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Table
            data={data.users.contents}
            tableWidth={3}
            header={[
              "姓名",
              "電話",
              "地址",
              "加入時間",
              "備註事項",
              "追蹤紀錄",
              "聯絡人員",
              "狀態",
              "轉為客戶",
            ]}
            columns={[
              "fullName",
              "mobile",
              (item) =>
                getAddress(
                  item.address?.division,
                  item.address?.subdivision,
                  item.address?.address
                ),
              (item) => moment(item.createdAt).format("YYYY/MM/DD"),
              "note",
              (item) => <Text>{item.record}</Text>,
              "contactPerson",
              "status",
              (item) => (
                <Grid container spacing={1} direction="column">
                  <Button
                    color="primary"
                    variant="contained"
                    onPress={(event) => {
                      event.stopPropagation();
                      changeData("open", true, true);
                    }}
                  >
                    轉為客戶
                  </Button>
                </Grid>
              ),
            ]}
            onPress={(item) => {
              onChangeSelect(item);
            }}
          />
          <TransferDialog
            changeCustomer
            open={newData.open}
            onClose={() => {
              changeData("open", false, true);
            }}
          />
        </CardContent>
        <CardActions>
          <Grid container justifyContent="center">
            <Pagination
              count={data.users.pageCount}
              size="large"
              color="primary"
              page={newData.page}
              onChange={(e, n) => {
                changeData("page", n, true);
              }}
            />
          </Grid>
        </CardActions>
      </Card>
    );
  } else {
    return null;
  }
}
